import arrowCorner from "../assets/arrowCorner.png";
import background from "../assets/background.png";
import authBg from "../assets/authBg.png";
import certi from "../assets/certi.png";
import certificate from "../assets/certificate.png";
import ilead from "../assets/ilead.png";
import no_data from "../assets/no_notification.png";
import not_available from "../assets/not_available.gif";
import profile from "../assets/profile.png";
import Quote from "../assets/Quote.png";
import student from "../assets/student.png";
import bronze from "../assets/bronze.png";
import signature from "../assets/signature.png";
import maxwellFoundation from "../assets/maxwellFoundation.png";
import africaNewLife from "../assets/africaNewLife.svg";

const images = {
  arrowCorner,
  background,
  authBg,
  certi,
  certificate,
  ilead,
  no_data,
  not_available,
  profile,
  Quote,
  student,
  bronze,
  signature,
  maxwellFoundation,
  africaNewLife,
};

export default images;
